import React from "react";

import { ParsedTCMPCUnit } from "@examspark/types";

import ContentSection from "../common/ContentSection";
import ResourcesTable from "../resources/ResourcesTable";

const UnitResources = (props: { unit: ParsedTCMPCUnit }) => {
  return (
    <ContentSection title="Resources">
      <ResourcesTable location={props.unit} />
    </ContentSection>
  );
};

export default UnitResources;
